module.exports = __webpack_public_path__ + "img/a-minimal-metaphysics-for-scientific-practice-cover.3fe4ae48.jpg";